// extracted by mini-css-extract-plugin
export default {"plus":"PlusComponent_plus__FvCJd"};